<template>
    <div class="container my-5">

        <div v-if="model.currentUser && model.currentUser.name" class="mb-4">
            <h4>Hello {{model.currentUser.name}} 👋</h4>
            <div class="text-muted">Welcome back to Webase!</div>
        </div>

        <div v-if="model.apps.length > 0" class="mt-2">

            <div class="d-flex justify-content-between">

                <div class="d-flex align-items-center">
                    <h5 class="mb-0">Workspace</h5>
                </div>

                <div>
                    <router-link :to="{ name: 'new-app'}" class="btn btn-primary btn-wide">
                        <i class="fas fa-plus"></i> create new app
                    </router-link>
                </div>
            </div>

            <div class="d-flex flex-wrap my-1" :class="model.isMobile ? 'justify-content-center' : ''">
                <div v-for="app in model.apps" class="p-3">
                    <router-link :to="openRouterLink(app)" class="no-underline">
                        <app-display :app="app" :default-theme-color="defaultThemeColor()" class="pointer"></app-display>
                    </router-link>
                </div>
            </div>

        </div>

        <div v-else>
            You have not created any apps yet.

            <div>
                <router-link :to="{ name: 'new-app'}" class="btn btn-primary btn-wide">
                    <i class="fas fa-plus"></i> create new app
                </router-link>
            </div>
        </div>

        <hr class="my-3">

        <h5>Templates</h5>
        <div><span class="badge text-bg-light">(ready made apps you can start with)</span></div>

        <div class="d-flex flex-wrap my-1" :class="model.isMobile ? 'justify-content-center' : ''">
            <div v-for="appTemplate in model.appTemplates" class="p-3">
                <a href="javascript:void(0)" @click="onTemplateClick(appTemplate)" class="no-underline">
                    <app-display :app="appTemplate" :default-theme-color="defaultThemeColor()"></app-display>
                </a>
            </div>
        </div>


<!--        <hr class="my-3">

        <div v-if="model.websites.length > 0" class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
                <h5 class="mb-0">Websites</h5>
            </div>
        </div>

        <div v-if="model.websites.length > 0" class="d-flex flex-wrap my-1" :class="model.isMobile ? 'justify-content-center' : ''">
            <div v-for="website in model.websites" class="p-3">

                <a href="javascript:void(0)" @click="onOpenWebsite(website)" class="no-underline">
                    <website-display :website="website" :default-theme-color="defaultThemeColor()"></website-display>
                </a>

            </div>
        </div>

        <website-form-modal v-if="showNewWebsiteModal" @noEvent="showNewWebsiteModal = false" :website="website"></website-form-modal>-->
    </div>
</template>

<script>
    import AppService from "./services/AppService";
    import ArrayUtil from "./utils/ArrayUtil";
    import AppTemplateService from "./services/AppTemplateService";
    import AppDisplay from "./components/AppDisplay.vue";
    import SiteService from "./services/SiteService";
    import WebsiteFormModal from "./editor/app/WebsiteFormModal.vue";
    import WebsiteDisplay from "./components/WebsiteDisplay.vue";
    import WebsiteTemplateService from "./services/WebsiteTemplateService";
    import UserService from "./services/UserService";
    import ResourcesService from "./services/ResourcesService";

    export default {
        name: 'Apps',
        components: {
            WebsiteDisplay,
            WebsiteFormModal,
            AppDisplay
        },
        data() {
            return {
                model: webase.model,
                service: new AppService(),
                templateService: new AppTemplateService(),
                siteTemplateService: new WebsiteTemplateService(),
                arrayUtil: new ArrayUtil(),
                showNewWebsiteModal: false,
                website: {
                    id: null,
                    name: '',
                    domain: ''
                }
            }
        },
        computed: {
            isAdmin() {
                return this.model.currentUser && webase.utils.user.isAdmin()
            }
        },
        mounted() {
            this.model.currentCollaboratorId = null

            let service = new UserService()
            service.current().then( (user) => {
                if(user.role === 'owner' || user.role === 'admin') {
                    service.permissions()
                }
            })

            this.model.app.id = null // hide app routes until app is opened

            this.templateService.list().then((templates) => {
                this.model.appTemplates = templates
            }).catch((error) => {
                console.log('Error loading app templates.')
                console.log(error)
            })

            this.service.list().then((apps) => {
                this.model.apps = apps

                if(apps.length === 0) {
                    this.$router.push({ name: 'new-app'})
                }

            }).catch((error) => {
                console.log('Error loading apps.')
                console.log(error)
            })

            let siteService = new SiteService()
            siteService.list().then((websites) => {
                this.model.websites = websites
            }).catch((error) => {
                console.log('Error loading website.')
                console.log(error)
            })

            let resourcesService = new ResourcesService()
            let url = webase.utils.app.getBaseUrl() + '/resources/webase-fonts.json?t=' + Date.now()
            resourcesService.get(url).then((response) => {
                this.model.fonts = response
            })
        },
        methods: {

            onNewSiteClick() {
                this.website = {
                    id: null,
                    name: '',
                    domain: '',
                    subdomain: ''
                }

                this.showNewWebsiteModal = true
            },

            openRouterLink( app ) {
                if(app.app_type === 'Website' && app.website_id) {
                    return {name: 'open-site', params: {appId: app.id, id: app.website_id}}
                }
                // } else if (app.app_type === 'Web3 App') {
                //   return {name: 'web3-app', params: {id: app.id}}
                // }

                return { name: 'open-app', params: {id: app.id}}
            },

            onTemplateClick(appTemplate) {

                this.templateService.createApp(appTemplate.id).then((app) => {
                    console.log('Created app from template.')
                    console.log(app)
                    this.$router.push({name: 'open-app', params: {id: app.id}})
                }).catch((error) => {
                    console.log('Error loading creating app from template.')
                    console.log(error)
                })
            },

            onOpenWebsite(website) {
                let page = website.webpages[0]
                this.$router.push({ name: 'page-editor', params: {pageId: page.slug}})
            },

            defaultThemeColor() {
                return '#5674F0'
            }
        }
    }
</script>

<style>

</style>
